import React from 'react';
import styled from 'styled-components';
import Loader from '~/components/Loader';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--neutral-1);
  opacity: 70%;
  z-index: ${props => props.theme.zIndex.loadingOverlay};
`;

function LoadingOverlay() {
  return (
    <Wrapper>
      <Loader />
    </Wrapper>
  );
}

export default LoadingOverlay;
